import { 
  REQUEST_FAQS,
  RECEIVE_FAQS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  faqs: [],
  loading: true,
};

function faqReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_FAQS: {
      return { ...state, loading: true };
    }
    case RECEIVE_FAQS: {
      return { 
        faqs: action.response,
        loading: false,
      };
    }
    default:
      return state;
  }
}

export default faqReducer;